import { useEffect } from "react";
import { createPortal } from "react-dom";

const PdfModal = (props) => {
  // const pdfSource = this.props.pdfSource;

  useEffect(() => {}, []);

  const handleCloseModal = () => {
    let tgPdfViewer = document.querySelector("#tgpdfviewer");
    let modalBackdrop = document.querySelector(".modal-backdrop");
    let tgPDFIframe = document.querySelector("#tgpdfviewer iframe");

    if (tgPdfViewer.classList.contains("in")) {
      tgPdfViewer.classList.toggle("in");
      setTimeout(() => {
        tgPdfViewer.style.display = "none";
        tgPDFIframe.src = "";
        if (modalBackdrop === undefined) {
          modalBackdrop.style.display = "none";
          modalBackdrop.classList.toggle("in");
        }
      }, 100);
    }
  };

  return createPortal(
    <div
      id="tgpdfviewer"
      className="modal fade"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="PDFModalLabel"
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-hidden="true"
              onClick={handleCloseModal}
            >
              &times;
            </button>
            <h4 className="modal-title">PDF</h4>
          </div>
          <div className="modal-body">
            <iframe src="" style={{ width: "100%", height: "80vh" }} title="pdfModal"></iframe>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("portal"),
  );
};

export default PdfModal;
